import { API_URL, INTERNAL_SECRET } from "@/env";
import { SearchReferralAPI } from "./type";

async function search_referral(keyword: string): Promise<SearchReferralAPI | void> {
    try {
        const response = await fetch(`${API_URL}/api/v1/be/referral/get-code?keyword=${encodeURIComponent(keyword)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Internal-Secret': INTERNAL_SECRET,
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const data = await response.json();
        return data;
    }
    catch (e) {
        console.error(e);
    }
}

export {
    search_referral,
}